export default "__VITE_ASSET__xBfvhvhy__"